import type { ReactNode } from 'react'

interface SectionCardProps {
  title: string
  action?: ReactNode
  children: ReactNode
  className?: string
}

export function SectionCard({
  title,
  action,
  children,
  className = '',
}: SectionCardProps) {
  return (
    <section
      className={`min-w-0 ${className}`}
    >
      <div className="mb-[22px] flex min-h-6 items-center justify-between">
        <h2 className="text-[18px] font-bold leading-none text-[#182235]">{title}</h2>
        {action ? <div>{action}</div> : null}
      </div>
      <div>{children}</div>
    </section>
  )
}
